import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [msg, setMsg] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMsg("");

        // Validations
        const passwordRegex = /^[a-zA-Z0-9]{6,}$/;
        if (!passwordRegex.test(password)) {
            setError("Password must be at least 6 characters (letters and numbers only).");
            return;
        }

        try {
            await api.post(`/api/auth/reset-password/${token}`, { password });
            setMsg("Password reset successful! Redirecting to login...");
            setTimeout(() => navigate("/login"), 2000);
        } catch (err) {
            setError(err.response?.data?.message || "Failed to reset password.");
        }
    };

    return (
        <div className="pt-5 d-flex align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-4">
                        <div className="card shadow border-0">
                            <div className="card-body p-4">
                                <div className="text-center mb-4">
                                    <h3 className="card-title text-primary">Reset Password</h3>
                                    <p className="text-muted">Enter your new password</p>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">New Password</label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                                minLength={6}
                                            />
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={showPassword ? "las la-eye-slash" : "las la-eye"}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100 py-2">
                                        Reset Password
                                    </button>
                                </form>

                                {msg && <div className="alert alert-success mt-3">{msg}</div>}
                                {error && <div className="alert alert-danger mt-3">{error}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
